<template>
  <div class="modal-out">
    <div class="modal" style="width: 1000px;">
      <div class="modal-header">
        <div class="title">睡倍健实时数据</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body" style="padding: 5px;">

        <div v-loading="tableLoading" style="min-height:400px;height: 430px;overflow: scroll;">

          <div v-for="item in tableData" :key="item" style="background-color: #fff;float: left;width: 25%;" >

            <el-card class="box-card" style="margin: 5px;">

              <div style="height: 50px;">
                <div>{{item.userInfo}}[<span v-if="item.onBed==1">在床</span><span v-else>离床</span>]</div>
                <div>设备：{{item.deviceId}}</div>
              </div>

              <div style="margin: 15px;">
                <div style="width: 100%;overflow: hidden;">
<!--                  <ve-line :data="chartData_total_day" :settings="chartSettings_total_day"-->
<!--                           :width="lineWidth" :height="lineHeight" style="height: 100px;"></ve-line>-->
                  <ve-line :data="item.data" :settings="chartSettings_total_day" :extend="chartExtend"
                           :width="lineWidth" :height="lineHeight"></ve-line>
                </div>
              </div>


            </el-card>

          </div>

          <div style="clear: both;"></div>
        </div>

        <div class="page" style="padding: 5px;">
          <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
          <div style="float: left;">
            <el-pagination small
                           background
                           layout="prev, pager, next"
                           :total="totalItems"
                           :page-size="pageSize"
                           :current-page.sync="currentPage"  @current-change="current_change"></el-pagination>
          </div>
          <div style="clear: both;"></div>
        </div>

      </div>
    </div>

  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffDTO} from "@/utils/auth";

export default {
  name: "SBJData",
  data() {
    return {

      tableLoading:false,

      userCode: "",
      userName:'',
      deviceId: "",

      tableData: [],
      totalItems: 0,
      pageSize: 8,
      currentPage: 1,

      arrUserCode:[],

      chartSettings_total_day:{
        labelMap:{
          time:"时间",
          heartBeat:"心率",
          respiratoryRate:"呼吸",
        }
      },
      chartData_total_day: {
        columns: ['time', 'heartBeat', 'respiratoryRate'],
        rows: [
          {'time':'1','heartBeat':'70','respiratoryRate':'19'},
          {'time':'2','heartBeat':'56','respiratoryRate':'23'},
          {'time':'3','heartBeat':'66','respiratoryRate':'16'},
          {'time':'4','heartBeat':'86','respiratoryRate':'13'},
          {'time':'5','heartBeat':'76','respiratoryRate':'21'},
        ]
      },

      lineWidth: '100%',//宽度
      //lineHeight: '5.7rem',//高度
      lineHeight: '80px',//高度

      chartExtend:{
        series: {
          barWidth: 10
        },
        tooltip: {
          trigger: 'none'
        },
        grid:{
          top:0,left:0,right:60,bottom:0,
        },
        legend: {
          orient: 'vertical',
          left: 'right',
          show:true,
        },

      },


      timer:'',

    }
  },
  components: {

  },

  destroyed() {
    clearInterval(this.timer);
  },

  methods: {
    init() {

      this.tableData = [];
      this.currentPage=1;

      this.getList();

    },
    closeSelf() {
      this.$emit("closeBigView");
      clearInterval(this.timer);
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      //var _this=this
      //this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceYjsbjian/PageByInsCode",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,

          deviceId: this.deviceId,
          userCode:this.userCode,
          institutionCode : getStaffDTO().institutionDTO.institutionCode,
        },
      }).then((response) => {
        //_this.tableLoading=false
        if (response.data.error == 0) {
          //this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;

          let datas = response.data.data.list;
          this.arrUserCode = [];
          for(let i=0;i<datas.length;i++){
            this.arrUserCode.push(datas[i].userCode);
          }

          if(this.arrUserCode.length>0){
            this.getListData();
            this.timer = setInterval(this.getListData,  2*60*1000);
          }


        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
        //_this.tableLoading=false
        console.log(error);
      });
    },

    getListData(){

      var _this=this
      _this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "SBJ/ListHeartRate",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          arr: this.arrUserCode,
        },
      }).then((response) => {
        _this.tableLoading=false;

        if (response.data.error == 0) {

          let data = response.data.data;

          for(let i=0;i<data.length;i++){
            let list = data[i].list;

            list = list.reverse();

            let rows = [];
            for(let j=0;j<list.length;j++){
              rows.push({'time':timefilters(list[j].sendDateTime).substring(11,16),'heartBeat':list[j].heartBeat,'respiratoryRate':list[j].respiratoryRate});
            }

            let dd =  {
                  columns: ['time', 'heartBeat', 'respiratoryRate'],
                  rows: rows,
                };

            data[i].data = dd;

          }

          this.tableData = data;

        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }

      }).catch(function (error) {
        _this.tableLoading=false;
        console.log(error);
      });
    },




  },

}


</script>

<style lang="scss" scoped>


</style>
